import { paths } from '@/config';
import classNames from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';

function FeatureList() {
  return (
    <div
      className={classNames({
        b__featureList_image_before: !window.isAuthed,
        b__featureList_image_after: window.isAuthed,
      })}
    >
      <div className="wrap">
        <div className="heading">Fish Saleを利用するにあたって</div>
        <div className="list_item">
          ・遊漁で使用できる漁具・漁法については
          <a
            href="http://www.jfa.maff.go.jp/j/yugyo/y_kisei/kisoku/todo_huken/"
            target="_blank"
            rel="noopener noreferrer"
          >
            こちら
          </a>
        </div>
        <div className="list_item">
          ・漁業者への配慮や遊漁については
          <a
            href="http://www.jfa.maff.go.jp/j/enoki/yugyo/"
            rel="noopener noreferrer"
            target="_blank"
          >
            こちら
          </a>
        </div>
        <div className="list_item">
          ・偽装表示の防止と不正競争防止法については
          <a
            href="https://www.meti.go.jp/policy/economy/chizai/chiteki/pdf/panfrethontai.pdf            "
            target="_blank"
            rel="noopener noreferrer"
          >
            こちら
          </a>
        </div>
        <div className="list_item">
          ・魚が売れた場合、サービス利用料10%がかかります
        </div>
        <Link to={paths.introduction.explain}>
          <Button content="Fish Saleについて" />
        </Link>
      </div>
    </div>
  );
}

export default FeatureList;
